import PinchZoom from 'pinch-zoom-element';

const clampNumber = (num, min, max) => Math.min(Math.max(num, min), max);

let lastY;
let lastX;

const init = function() {
    const component = document.querySelector(".product-fullscreen-zoom");
    if (!component) return;

    const buttonsZoom = component.querySelectorAll('.product-zoom-button');
    const currentValue = component.querySelector('.product-zoom-current');
    const zoomImage = document.querySelector('.product-fullscreen-image');
    const zoomStep = 50;
    const minScale = 100;
    const maxScale = 200;
    let currentPercentage = 100;
    let referenceScale = 1;
    let isZooming = false;
    let wheelTimeout;
    let isWheeling = false;
    let prevScale;

    const pinchZoom = document.querySelector('.product-fullscreen-pinchable-image');
    const minusButton = component.querySelector('[data-zoom="minus"]');
    const plusButton = component.querySelector('[data-zoom="plus"]');

    const moveToSafeArea = function(currentPercentage) {
        const wrapper = pinchZoom;
        if (!wrapper) return;
        const content = wrapper.children[0];
        if (!content) return;

        const wrapperWidth = wrapper.clientWidth;
        const wrapperHeight = document.documentElement.clientHeight;

        const contentWidth = content.clientWidth * wrapper.scale;
        const contentHeight = content.clientHeight * wrapper.scale;

        content.classList.add('moving');

        let safeX = wrapper.x;
        let safeY = wrapper.y;

        const safeRangeX = wrapperWidth - contentWidth;
        const safeRangeY = wrapperHeight - contentHeight;

        // Centra se più piccola del viewport
        if (contentWidth <= wrapperWidth) {
            safeX = (wrapperWidth - contentWidth) / 2;
        } else {
            safeX = Math.min(0, Math.max(safeRangeX, safeX));
        }

        if (contentHeight <= wrapperHeight) {
            safeY = (wrapperHeight - contentHeight) / 2;
        } else {
            safeY = Math.min(0, Math.max(safeRangeY, safeY));
        }

        const maxAllowedScale = (maxScale / 100) * referenceScale;
        const pinchPercentage = Math.floor((wrapper.scale / referenceScale) * 100);
        if (safeX !== wrapper.x || safeY !== wrapper.y) {
            wrapper.setTransform({
                scale: wrapper.scale < maxAllowedScale ? wrapper.scale : maxAllowedScale,
                x: pinchPercentage > maxScale ? lastX : safeX,
                y: pinchPercentage > maxScale ? lastY : safeY,
                allowChangeEvent: false
            });
        }

        if ((pinchPercentage < maxScale) || (!isZooming && !isWheeling && pinchPercentage === maxScale)) {
            lastX = wrapper.x;
            lastY = wrapper.y;
        }

        setTimeout(() => {
            content.classList.remove('moving');
        }, 250);
    };

    function setTransform(targetScale) {
        if (!pinchZoom) return;

        const maxAllowedScale = (maxScale / 100) * referenceScale;
        const minAllowedScale = (minScale / 100) * referenceScale;
        const clampedScale = clampNumber(targetScale, minAllowedScale, maxAllowedScale);

        // Mantieni il centro visivo costante
        const newX = window.innerWidth / 2 - ((window.innerWidth / 2 - pinchZoom.x) * (clampedScale / pinchZoom.scale));
        const newY = window.innerHeight / 2 - ((window.innerHeight / 2 - pinchZoom.y) * (clampedScale / pinchZoom.scale));

        pinchZoom.setTransform({
            scale: clampedScale,
            x: newX,
            y: newY,
            allowChangeEvent: true
        });

        moveToSafeArea(currentPercentage);
    }

    function updateZoomDisplay() {
        currentPercentage = Math.floor((pinchZoom.scale / referenceScale) * 100);
        currentValue.textContent = currentPercentage;
        minusButton.classList.toggle('disabled', currentPercentage <= minScale);
        minusButton.disabled = currentPercentage <= minScale;

        plusButton.classList.toggle('disabled', currentPercentage >= maxScale);
        plusButton.disabled = currentPercentage >= maxScale;

        moveToSafeArea(currentPercentage);
    }

    function setInitialZoom() {
        if (!zoomImage || zoomImage.naturalWidth <= 0 || zoomImage.naturalHeight <= 0) return;

        referenceScale = Math.min(
            window.innerWidth / zoomImage.naturalWidth,
            window.innerHeight / zoomImage.naturalHeight
        );

        pinchZoom.minScale = referenceScale;

        // Applica transform iniziale centrata
        setTransform(referenceScale);

        // Aggiorna display a 100%
        currentPercentage = 100;
        currentValue.textContent = currentPercentage;
        minusButton.disabled = true;
        const plusButton = component.querySelector('[data-zoom="plus"]');
        plusButton.disabled = false;

        plusButton.classList.toggle('disabled', currentPercentage >= maxScale);
        plusButton.disabled = currentPercentage >= maxScale;


    }

    function handleZoomChange(e) {
        const maxAllowedScale = (maxScale / 100) * referenceScale;
        const minAllowedScale = (minScale / 100) * referenceScale;

        let targetScale = pinchZoom.scale;
        if (e instanceof WheelEvent) {
            targetScale = prevScale * (e.deltaY > 0 ? 0.95 : 1.05);
        }

        let clampedScale = clampNumber(targetScale, minAllowedScale, maxAllowedScale);
        let pinchPercentage = Math.round((targetScale / referenceScale) * 100);
        currentPercentage = Math.round((clampedScale / referenceScale) * 100);

        if (pinchPercentage !== currentPercentage || (isWheeling && clampedScale < prevScale)) {
            pinchZoom.setTransform({
                scale: clampedScale,
                x: targetScale >= maxAllowedScale ? lastX : pinchZoom.x,
                y: targetScale >= maxAllowedScale ? lastY : pinchZoom.y,
                allowChangeEvent: false
            });
        }

        prevScale = clampedScale;

        currentValue.textContent = currentPercentage;
        minusButton.classList.toggle('disabled', currentPercentage <= minScale);
        minusButton.disabled = currentPercentage <= minScale;

        plusButton.classList.toggle('disabled', currentPercentage >= maxScale);
        plusButton.disabled = currentPercentage >= maxScale;

        moveToSafeArea(currentPercentage);
    }

    pinchZoom.addEventListener('change', updateZoomDisplay);

    buttonsZoom.forEach(button => {
        button.addEventListener('click', function(e) {
            let targetDisplayPercentage = currentPercentage +
                (e.target.dataset.zoom === "plus" ? zoomStep : -zoomStep);
            targetDisplayPercentage = clampNumber(targetDisplayPercentage, minScale, maxScale);

            const targetScale = (targetDisplayPercentage / 100) * referenceScale;
            setTransform(targetScale);
        });
    });

    pinchZoom.addEventListener('change', handleZoomChange);


    pinchZoom.addEventListener('touchend', () => {
        isZooming = false;
    });

    pinchZoom.addEventListener('touchmove', (e) => {
        if (e.touches.length !== 2) {
            isZooming = false;
            return;
        }
        isZooming = true;
        handleZoomChange(e);
    });

    pinchZoom.addEventListener('wheel', (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();

        if (!isWheeling) {
            isWheeling = true;
        }
        handleZoomChange(e);

        clearTimeout(wheelTimeout);

        wheelTimeout = setTimeout(() => {
            isWheeling = false;
        }, 150);
    });

    const observer = new MutationObserver(mutationList => {
        mutationList.forEach(mutation => {
            if (!mutation.attributeName.includes('src')) return;

            if (zoomImage.complete) {
                setInitialZoom();
            } else {
                zoomImage.addEventListener('load', setInitialZoom, { once: true });
            }
        });
    });

    observer.observe(zoomImage, { attributes: true });

    if (zoomImage.complete) {
        setInitialZoom();
    } else {
        zoomImage.addEventListener('load', setInitialZoom, { once: true });
    }
}

export {init};
